import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled('div')`
  display: flex;
  gap: 24px;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;
  }
`;
